import pagination from '../../utils/pagination'
import {
  TICKETS_BATCH_DELETE_REQUEST, TICKETS_BATCH_DELETE_SUCCESS, TICKETS_BATCH_DELETE_FAILURE,
  TICKETS_FETCH_MANY_REQUEST, TICKETS_FETCH_MANY_SUCCESS, TICKETS_FETCH_MANY_FAILURE,
  TICKETS_FETCH_ALL_REQUEST, TICKETS_FETCH_ALL_SUCCESS, TICKETS_FETCH_ALL_FAILURE,
  TICKETS_FETCH_REQUEST, TICKETS_FETCH_SUCCESS, TICKETS_FETCH_FAILURE,
  TICKETS_SAVE_REQUEST, TICKETS_SAVE_SUCCESS, TICKETS_SAVE_FAILURE,
  TICKETS_PROCESS_REQUEST, TICKETS_PROCESS_SUCCESS, TICKETS_PROCESS_FAILURE,

  EMPTY_TICKETS,
  CLEAR_ERRORS
} from './types'

export default {
  [TICKETS_BATCH_DELETE_REQUEST] (state) {
    state.deleting = true
  },
  [TICKETS_BATCH_DELETE_SUCCESS] (state) {
    state.deleting = false
  },
  [TICKETS_BATCH_DELETE_FAILURE] (state) {
    state.deleting = false
  },
  [TICKETS_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [TICKETS_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data
    state.page = pagination(data)
    state.loading = false
  },
  [TICKETS_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [TICKETS_FETCH_ALL_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [TICKETS_FETCH_ALL_SUCCESS] (state, { data }) {
    state.data = data
    state.loading = false
  },
  [TICKETS_FETCH_ALL_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [TICKETS_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [TICKETS_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [TICKETS_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [TICKETS_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [TICKETS_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [TICKETS_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [TICKETS_PROCESS_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [TICKETS_PROCESS_SUCCESS] (state) {
    state.saving = false
  },
  [TICKETS_PROCESS_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_TICKETS] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  },
}
